import React from 'react'
import { Link } from 'react-router-dom'

export const PaymentSuccess: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-white flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full text-center">
        <div className="mx-auto h-20 w-20 flex items-center justify-center bg-green-100 rounded-full mb-8">
          <svg className="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        
        <h1 className="text-4xl font-extrabold text-gray-900 mb-4">
          Payment Successful!
        </h1>
        
        <p className="text-xl text-gray-700 mb-8 leading-relaxed">
          Thank you for your purchase. You should receive your access details via email shortly.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-colors text-center no-underline"
          >
            Return to Homepage
          </Link>
        </div>
      </div>
    </div>
  )
}
